var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.804
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h17v17H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.417a7.084 7.084 0 1 0 .002 14.168A7.084 7.084 0 0 0 8.5 1.417zm0 3.141a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4zm1.6 7.255c0 .19-.154.343-.343.343H7.243a.343.343 0 0 1-.342-.343v-.685c0-.19.153-.343.342-.343h.343V8.957h-.343a.343.343 0 0 1-.342-.343V7.93c0-.19.153-.343.342-.343h1.828c.19 0 .343.153.343.343v2.856h.343c.189 0 .342.153.342.343v.685z",
    fill: "#E1E1E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoCircle);
export default __webpack_public_path__ + "static/media/icon-info-circle.7f76f447.svg";
export { ForwardRef as ReactComponent };